// extracted by mini-css-extract-plugin
module.exports = {"root":"DateChip_root__InICh","timezone":"DateChip_timezone__3xuhY"};